<template>
  <div>
    <div class="row align-items-center mb-3">
      <div class="col-md-4">
        <p class="font-weight-bold text-dark mb-0 h5">Transaction history</p>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-4">
            <div class="font-weight-bold text-muted mb-1">
              Filter Type
            </div>
            <a-select default-value="all" style="width: 100%" @change="handleTypeChange">
              <a-select-option value="all">
                All
              </a-select-option>
              <a-select-option :value="0">
                Sent
              </a-select-option>
              <a-select-option :value="1">
                Recharge
              </a-select-option>
            </a-select>
          </div>
          <div class="col">
            <div class="font-weight-bold text-muted mb-1">
              Filter between dates
            </div>
            <a-range-picker @change="onDateChange" style="width:100%"/>
          </div>
        </div>
      </div>
    </div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :loading="loading"
      >
        <template slot="created_at" slot-scope="created_at">
          <span>{{ moment(created_at).format('lll') }}</span>
        </template>
        <template slot="type" slot-scope="type">
          <div>
            <div :class="[type == 1 ? 'text-success' : 'text-danger', 'font-weight-bold']">{{parseType(type)}}</div>
          </div>
        </template>
        <template slot="from" slot-scope="from">
          <div>{{from ? from : 'NA'}}</div>
        </template>
        <template slot="credit" slot-scope="credit">
          <span class="font-weight-bold">{{ credit.type ? credit.credit : '-' + credit.credit }}</span>
        </template>
        <template slot="amount" slot-scope="amount">
          <span>{{amount ? '₹' + amount : 'NA'}}</span>
        </template>
      </a-table>
    </div>
    <div class="text-right">
      <a-pagination
          showSizeChanger
          @showSizeChange="onShowSizeChange"
          :total="meta.total"
          :pageSize.sync="pageSize"
          v-model="current"
          @change="onChange"
        >
      </a-pagination>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

const columns = [
  {
    title: 'Date',
    dataIndex: 'created_at',
    key: 'created_at',
    scopedSlots: { customRender: 'created_at' },
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: 'From',
    dataIndex: 'from',
    key: 'from',
    scopedSlots: { customRender: 'from' },
  },
  {
    title: 'Credit',
    key: 'credit',
    scopedSlots: { customRender: 'credit' },
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    scopedSlots: { customRender: 'amount' },
  },
]

export default {
  name: 'SmsTransactionsTable',
  mounted() {
    this.getTransactions()
    this.$eventBus.$on('smsRecharged', this.getTransactions)
  },
  props: {
    schoolId: {
      type: Number,
    },
    reload: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'admin',
    },
  },
  data: function() {
    return {
      columns,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      loading: false,
      filterType: null,
      filterStartDate: null,
      filterEndDate: null,
      reloadTransactions: false,
    }
  },
  watch: {
    reload: function (val) {
      if (val) {
        this.getTransactions()
      }
    },
  },
  methods: {
    moment,
    parseType(type) {
      const types = {
        0: 'Sent',
        1: 'Recharge',
      }

      return types[type]
    },
    getTransactions() {
      this.loading = true
      let url = '/api/sms/transactions'
      if (this.type === 'superadmin') {
        url = `/api/school/sms/transactions/${this.schoolId}`
      }
      this.$http.get(url, {
        params: {
          limit: this.pageSize,
          page: this.current,
          type: this.filterType,
          start_date: this.filterStartDate,
          end_date: this.filterEndDate,
        },
      })
        .then(({ data }) => {
          this.data = data.data
          this.meta = data.meta
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    handleDate($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getTransactions()
    },
    onChange(current) {
      this.current = current
      this.getTransactions()
    },

    handleTypeChange(value) {
      if (value === 0 || value === 1) {
        this.filterType = value
      } else {
        this.filterType = null
      }
      this.getTransactions()
    },
    onDateChange(date, dateString) {
      this.filterStartDate = dateString[0] ? dateString[0] : null
      this.filterEndDate = dateString[1] ? dateString[1] : null

      this.getTransactions()
    },
  },
}
</script>
